module.exports = __webpack_public_path__ + "static/media/Illus-Nutrition_2@2x.793d4de7.png";